import angular from 'angular';
import {
  authorizationService, loaderService, orgDataService, userService
} from 'app/services';
import { alerts } from 'app/components/global';
import PasswordResetFormController from './password-reset.controller';
import passwordResetFormDirective from './password-reset.directive';


export const routeConfigPasswordReset = {
  template: require('./password-reset.html'),
  controller: 'PasswordResetFormController',
  controllerAs: 'passwordResetVM',
};

export default angular.module('app.components.membership.passwordResetForm', [
  'ngMessages',
  alerts,
  authorizationService,
  userService,
  loaderService,
  orgDataService
])
  .directive('passwordResetForm', passwordResetFormDirective)
  .controller('PasswordResetFormController', PasswordResetFormController)
  .name;

console.log('app.components.membership.passwordResetForm created');
